import { useSyncViewportLayout } from '@hooks/useViewportLayout'
import { useUiPresentationStore } from '@store'
import { DesktopChrome } from './DesktopChrome'
import { TouchChrome } from './TouchChrome'

/**
 * Elige chrome según layout. Desktop = UI histórica.
 * tabletH / tabletV / mobile = TouchChrome (canvas + sheets).
 * El Canvas Three.js NO se monta aquí.
 *
 * Correspondencia: ATEMPORAL mobile-28-07-2026 (`47ee2081`).
 */
export function ResponsiveShell() {
  useSyncViewportLayout()
  const layout = useUiPresentationStore((s) => s.layout)

  if (layout === 'desktop') {
    return <DesktopChrome />
  }

  return <TouchChrome />
}
